import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Link } from "react-router-dom";
import "./StatusTile.css";

export const StatusTile = ({ icon, quantity, title, path, status }) => {
  return (
    <>
      <Link
        to={{
          pathname: path,
          status: status,
        }}
      >
        <div className="py-7 text-center tile-wrapper">
          <div className="mb-5">{icon}</div>
          <div style={{ fontSize: "2rem" }} className="mb-3 text-center">
            {quantity || quantity === 0 ? (
              quantity
            ) : (
              <div style={{ position: "relative", left: "42%" }}>
                <Skeleton variant="circle" width={40} height={40} />
              </div>
            )}
          </div>
          <div style={{ fontSize: "1rem" }}>{title}</div>
        </div>
      </Link>
    </>
  );
};
